<template lang="pug">
  .table-line.job-row
    .col.accordion
      span
    .col.check
      span
    GroupingJobTableFavoriteStar(:job="job", @update="update", :updateFavorForIndex="updateFavorForIndex")
    .col.company-mark
      span
    .col.company-name
      span
    .col.company-tel
      span
    .col.jobtype-name
      a(@click="display")
        | {{ job.jobtype_name }}
    .col.only-sp.job-row-sp
      span.only-sp
        | メディア
      span
        | {{ job.media_name }}
    .col.only-sp.job-row-sp
      span.only-sp
        | 広告プラン
      span
        | {{ job.article_plan_name }}
    .col.only-pc.salary
      span
        | {{ job.salary }}
    .col.job-row-sp
      span.only-sp
        | 掲載開始日
      span
        | {{ job.acquisition_date }}
    .col.only-pc
      span(v-for="c in job.view_end_date")
        | {{ c }}
        br
    .col.posting-situation
      span.view(v-if="job.posting")
        | 掲載中
      span.view-end(v-else)
        | 終了
    .col.only-pc
      span
        | {{ job.media_name }}
    .col.only-pc
      span(v-if="job.article_plan") {{ job.article_plan.toLocaleString("ja-JP") }}万円
      span(v-if="job.article_plan === 0") 0円
      span(v-else) &nbsp;
    .col.new.job-row-sp
      span.label(v-if="job.is_new") NEW
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import GroupingJobTableFavoriteStar from './JobTableFavoriteStar'

  export default {
    components: { GroupingJobTableFavoriteStar },
    props: ['job', 'modal', 'updateFavorForIndex'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
    },
    methods: {
      ...mapMutations('job', ['clearDetail']),
      update () {
        this.clearDetail()
      },
      display (e) {
        e.stopPropagation()
        this.$emit('display', { id: this.job.id })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/grouping-job/JobTableRow.vue